export default __webpack_public_path__ + "static/NavRingInnerHidden-0ddc0ca94bbee836c793451d878ea97a.png";